import { useOutletContext } from 'react-router-dom'
import type { AgentYamlConfig } from '@/lib/agentYaml'
import type { AgentDetail, CreateAgentMemoryEntryRequest } from '@/types'

export const PENDING_MEMORY_CONFLICT_MESSAGE =
  'The memory entries you added need Project memory. Turn it on in Memory Scope or remove them from Memory.'

export interface PendingAgentMemoryEntry extends CreateAgentMemoryEntryRequest {
  key: string
}

export interface AgentDetailContext {
  projectId: string
  agent: AgentDetail | null
  canEdit: boolean
  canReadMemory: boolean
  memoryAgentId: string | null
  pendingMemories: PendingAgentMemoryEntry[]
  pendingMemoryConflict: boolean
  onQueueMemory: (entry: CreateAgentMemoryEntryRequest) => string | null
  onRemovePendingMemory: (key: string) => void
  editorYaml: string
  onYamlChange: (yaml: string) => void
  parsedConfig: AgentYamlConfig | null
  unknownYamlKeys: string[]
  displayName: string
  onDisplayNameChange: (value: string) => void
  internalName: string
  onInternalNameChange: (value: string) => void
  internalNameError: string | null
  showValidation: boolean
  description: string
  onDescriptionChange: (value: string) => void
  missingRequiredFields: string[]
  isDirty: boolean
  isSaving: boolean
  saveBlockedReason: string | null
  onSave: () => void
  onCancel: () => void
  onExport: () => void
}

export function useAgentDetailContext(): AgentDetailContext {
  return useOutletContext<AgentDetailContext>()
}
